import { render } from "./color_preview.vue?vue&type=template&id=08d1c2ea"
import script from "./color_preview.vue?vue&type=script&lang=js"
export * from "./color_preview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__